const dashIconPhotos = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fill-rule="evenodd">
        <rect width="24" height="24"/>
        <g fill="#FFF" fill-rule="nonzero">
          <path d="M16,2 L16,12.002 L18,12.002 L18,2 C18,0.8954305 17.1045695,-2.02906125e-16 16,0 L13.414,0 L13.414,0 L2,0 C0.897,0 0,0.898 0,2 L0,20 C0,21.103 0.897,22 2,22 L12,22 L12,20 L2,20 L2,2 L12,2 L16,2 Z"/>
          <path d="M9,12 C7.159,12 6,13.16 6,15 L12,15 C12,13.16 10.841,12 9,12 Z"/>
          <circle cx="9" cy="9" r="2"/>
          <polygon points="19 14.585 14.293 19.292 15.707 20.706 18 18.413 18 24 20 24 20 18.413 22.293 20.706 23.707 19.292"/>
        </g>
      </g>
    </svg>
`;

export default dashIconPhotos;
